import { Sparkles } from "lucide-react";
import {
  ANNOUNCEMENTS,
  isRecentAnnouncement,
  latestAnnouncement,
} from "@brewbase/lib";
import { useAnnouncementStore } from "./announcement-store";

/**
 * The foot of the home page's rail points at the latest announcement for the
 * week after its release, so anyone who closed it too fast (or was never
 * offered it) can watch it again. After that it is only in search.
 */
export function WhatsNewHighlight() {
  const open = useAnnouncementStore((state) => state.open);
  const latest = latestAnnouncement(ANNOUNCEMENTS);
  if (!latest || !isRecentAnnouncement(latest, new Date())) return null;

  return (
    <button
      type="button"
      onClick={() => open(latest.id)}
      className="group flex w-full flex-col gap-1 border-l-2 border-farmless-green-9 bg-farmless-green-3 px-2 py-2 text-left transition-colors hover:bg-farmless-green-4"
    >
      <span className="flex items-center gap-1.5 text-xs font-medium uppercase tracking-widest text-farmless-green-9">
        <Sparkles className="size-3 shrink-0" />
        What's new
      </span>
      <span className="line-clamp-3 text-sm text-olive-12">{latest.title}</span>
      <span className="text-xs text-olive-11 group-hover:text-olive-12">Watch →</span>
    </button>
  );
}
